export default __webpack_public_path__ + "static/soehne-breit-dreiviertelfett-495e7f14771929f5e3317044bfd399fc.woff2";